import React, {FunctionComponent} from "react";
import CommandDonutChart, {DonutItem} from "./CommandDonutChart";
import {CommandCountByStatus} from "../reactQuery/CommandCountByStatusReactQuery";

interface Props {
    data: CommandCountByStatus[] | undefined;
    height?: number;
}

const SUCCESS_COLOR = "#1BB483";
const FAILURE_COLOR = "#D32F2F";

const CommandsByStatusDonutChart: FunctionComponent<Props> = ({data, height}) => {
    const items: DonutItem[] = React.useMemo(() => {
        const successCount = (data ?? []).find(item => item.success === true)?.count ?? 0;
        const failureCount = (data ?? []).find(item => item.success === false)?.count ?? 0;
        return [
            {name: "Sucesso", value: successCount, color: SUCCESS_COLOR},
            {name: "Falha", value: failureCount, color: FAILURE_COLOR},
        ];
    }, [data]);

    return <CommandDonutChart items={items} height={height}/>;
};

export default CommandsByStatusDonutChart;
